import React, { useRef, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Header from './components/Header';
import Footer from './components/Footer';
import HeaderContext from './context/HeaderContext';

const Base = ({ children }) => {
  const headerRef = useRef(null);
  const location = useLocation();

  // Check if current page is the cart page
  const isCartPage = location.pathname.startsWith('/cart');

  // Memoized context value
  const headerContextValue = useMemo(() => ({
    updateCart: () => {
      console.log('HeaderContext.updateCart called');
      if (headerRef.current && headerRef.current.updateCart) {
        console.log('Calling headerRef.current.updateCart()');
        headerRef.current.updateCart();
      } else {
        console.warn('headerRef.current or updateCart not available');
      }
    },
    updatePrintCash: () => {
      console.log('HeaderContext.updatePrintCash called');
      if (headerRef.current && headerRef.current.updatePrintCash) {
        console.log('Calling headerRef.current.updatePrintCash()');
        headerRef.current.updatePrintCash();
      } else {
        console.warn('headerRef.current or updatePrintCash not available');
      }
    }
  }), []);

  const updateHeader = () => {
    headerContextValue.updateCart();
    headerContextValue.updatePrintCash();
  };

  return (
    <HeaderContext.Provider value={headerContextValue}>
      <Box minH="100vh" bg="white" m={0} p={0}>
        <noscript>
          <iframe
            title="tagmanager"
            src="https://www.googletagmanager.com/ns.html?id=GTM-5WPX5H"
            height="0"
            width="0"
            style={{ display: 'none', visibility: 'hidden' }}
          />
        </noscript>

        <Header ref={headerRef} onUpdate={updateHeader} />

        <Box m={0} p={0}>
          {children}
        </Box>

        {/* Hide footer on cart page */}
        {!isCartPage && <Footer />}
    </Box>
    </HeaderContext.Provider>
  );
};

export default Base;
